import { FonteDadosProxyRotaAbstract } from './fonte-dados-proxy-rota-abstract.model';
import { FonteDadosProxyParametroConfig } from './fonte-dados-proxy-parametro';

export class FonteDadosProxyRotaPadrao extends FonteDadosProxyRotaAbstract {
  rota: string;

  constructor(
    rota: string,
    config?: {
      metodo?: string;
      tipoResposta?: 'arraybuffer' | 'blob' | 'json' | 'text';
      pathParam?: FonteDadosProxyParametroConfig;
    }
  ) {
    if (!config) {
      config = {};
    }
    super(rota, config.metodo, config.tipoResposta);
    this.criarParametro(config.pathParam);
  }

  private criarParametro(params?: FonteDadosProxyParametroConfig) {
    if (!params) {
      params = {
        nome: 'origemId',
        rotulo: 'Origem ID',
        obrigatorio: true,
        titulo: 'Identificador do registro na fonte de dados',
      };
    }

    this.adicionarParametroPath(params.nome, params.rotulo, 0, params);
  }
}
